import { ForwardedRef, forwardRef } from "react"
import { FormSelect, FormSelectProps } from "./Select"

const monthsOptions = {
  0: "Leden",
  1: "Únor",
  2: "Březen",
  3: "Duben",
  4: "Květen",
  5: "Červen",
  6: "Červenec",
  7: "Srpen",
  8: "Září",
  9: "Říjen",
  10: "Listopad",
  11: "Prosinec",
} as const

type Props = Omit<FormSelectProps<typeof monthsOptions>, "options" | "placeholder" | "required">

function MonthSelectRaw(props: Props, ref: ForwardedRef<HTMLSelectElement>) {
  const { id = "month", ...rest } = props
  return <FormSelect id={id} ref={ref} options={monthsOptions} placeholder="Měsíc" required {...rest} />
}

export const MonthSelect = forwardRef(MonthSelectRaw)
